export default __webpack_public_path__ + "static/media/imageTum1.271d4ab1.jpg";